import { Card, CardActionArea, CardContent, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ServiceCard = ({
  icon: Icon,
  title,
  description,
  path,
  image,
  compact = false,
}) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        backgroundColor: "#0d0a04",
        border: "1px solid rgba(201,168,76,0.2)",
        borderRadius: "8px",
        height: "100%",
        transition: "all 0.35s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 16px 48px rgba(0,0,0,0.5)",
          borderColor: "secondary.main",
          "& .card-overlay": { opacity: 1 },
        },
      }}
    >
      <CardActionArea
        onClick={() => navigate(path)}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          "&:hover .MuiCardActionArea-focusHighlight": { opacity: 0 },
        }}
      >
        {/* Icon / Image area */}
        <Box
          sx={{
            height: 200,
            position: "relative",
            overflow: "hidden",
            borderRadius: "8px 8px 0 0",
            backgroundColor: "#0d0a04",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {image ? (
            <Box
              component="img"
              src={image}
              alt={title}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "fill",
                display: "block",
                transition: "transform 0.4s ease",
                ".MuiCardActionArea-root:hover &": { transform: "scale(1.05)" },
              }}
            />
          ) : (
            <Box sx={{
              width: "100%", height: "100%",
              display: "flex", alignItems: "center", justifyContent: "center",
              position: "relative",
              "&::before": {
                content: '""', position: "absolute", inset: 0,
                background: "radial-gradient(ellipse at center, rgba(201,168,76,0.1) 0%, transparent 65%)",
              },
            }}>
              <Icon sx={{
                fontSize: 110,
                color: "rgba(201,168,76,0.75)",
                position: "relative", zIndex: 1,
                filter: "drop-shadow(0 0 18px rgba(201,168,76,0.35))",
                transition: "transform 0.3s ease, color 0.3s ease",
                ".MuiCardActionArea-root:hover &": {
                  transform: "scale(1.08)",
                  color: "rgba(201,168,76,1)",
                },
              }} />
            </Box>
          )}

          {/* Gold line at bottom of icon area */}
          <Box sx={{
            position: "absolute", bottom: 0, left: "15%", right: "15%",
            height: "1px", backgroundColor: "rgba(201,168,76,0.2)", zIndex: 2,
          }} />

          <Box className="card-overlay" sx={{
            position: "absolute", inset: 0,
            background: "linear-gradient(to top, rgba(201,168,76,0.15) 0%, transparent 60%)",
            opacity: 0, transition: "opacity 0.35s ease", zIndex: 1,
          }} />
        </Box>

        {/* Content */}
        <CardContent sx={{
          p: 2.5, flexGrow: 1,
          display: "flex", flexDirection: "column", textAlign: "center",
          backgroundColor: "#0d0a04",
        }}>
          <Typography variant="h5" sx={{
            color: "secondary.main",
            fontFamily: "'Playfair Display', serif",
            fontWeight: 600,
            fontSize: "1rem",
            mb: 1.2,
            letterSpacing: "0.02em",
          }}>
            {title}
          </Typography>
          <Box sx={{ width: 30, height: "1px", backgroundColor: "rgba(201,168,76,0.3)", mx: "auto", mb: 1.2 }} />
          <Typography variant="body2" sx={{
            color: "rgba(255,255,255,0.55)",
            lineHeight: 1.8,
            fontSize: "0.82rem",
            flexGrow: 1,
          }}>
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ServiceCard;